<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/products-download/products-download']">
    <span translate>COMMONS.PRODUCTS</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a (click)="openRelease()">
    <span translate>{{ productDto.Description }}</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>PRODUCTS.FAMILY</span>
</div>
<tb-header specificTitle="PRODUCTS.FAMILY"></tb-header>



<div class="contentGlobal" style="text-align: center" *ngIf="!isLoading">
  <div class="cards-grid-container" style="display: flex; flex-direction: column; align-items: center; gap: 2rem; width:100%; ">

    <div class="inputSearchStyle" [formGroup]="search" style=" width:100%; " >
      <div class="inputSearchStyle">
        <mat-form-field appearance="outline">
          <mat-label translate>Cerca prodotto</mat-label>
          <mat-icon matPrefix [inline]="true">search</mat-icon>
          <input matInput placeholder="Cerca" formControlName="searchString" />
          <mat-icon matSuffix [inline]="true" (click)="clearSearch()" class="pointer">highlight_off</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <div class="cards-grid-container" style="display: flex; flex-direction: row;  justify-content: space-between !important; width:100%; ">
      <div class="filter-container" *ngIf="this.productDownloadService?.isPlatinumPartner">
        <span style="font-weight: 600; font-size: 0.9rem;" translate>COMMONS.FILTER_BY</span>
        <button *ngFor="let filter of filterStrings" mat-stroked-button (click)="activeFilter = filter" [class]="getButtonFilterClasses(filter)">
          <div>
            {{ getButtonFilterText(filter) }}
          </div>
        </button>
      </div>
      <div class="filter-container">
        <span style="font-weight: 600; font-size: 0.9rem;" translate>COMMONS.ORDER_BY</span>
        <button *ngFor="let order of orderStrings" mat-stroked-button (click)="ActiveOrder(order)" [class]="getButtonOrderClasses(order)">
          <div>
            {{ getButtonOrderText(order) }}
          </div>
        </button>
      </div>
    </div>
    
  </div>

    <div class="cards-grid-container"  *ngIf="getVisibleReleases().length > 0">
      <div class="card-wrapper card-wrapper--30" *ngFor="let productRelease of getVisibleReleases()">
        <ms-product-version-card [productRelease]="productRelease" [family]="productDto.Family" [isLargeVersionCard]="false"></ms-product-version-card>
      </div>
    </div>
    <div class="cards-grid-container"  *ngIf="getVisibleReleases().length == 0">
    <p translate class="message-box info" style="width:100%; text-align:left;" >
      COMMONS.NO_ELEMENTFOUND</p>
    </div>
</div>

<div *ngIf="isLoading">
  <tb-loading></tb-loading>
</div>
